/* Short entrances on normal navigation; completed state on browser Back. */
(() => {
  const root = document.documentElement;
  // Every document navigation runs the content intro. Frame continuity is separate.
  root.classList.remove('ak-carousel-page-revisit');
  window.akCommitCarouselRevisit = section => {
    if (!root.classList.contains('ak-carousel-page-revisit') || !section) return;
    section.classList.add('ak-section-visible','ak-images-visible',
      'ak-desktop-cover-ready','ak-desktop-image-ready','ak-view-collection-ready',
      'ak-mobile-preexpanded-cross','ak-mobile-bottom-ready','ak-mobile-cross-finished',
      'ak-mobile-cross-image-ready','ak-mobile-slide-hint-ready','ak-mobile-reveal-complete',
      'is-ak-featured-initial-ready','ak-vpcompress22-carousel-border',
      'ak-papers-front-preexpanded-visible','ak-paper-title-ready','ak-paper-cta-ready');
    section.dataset.akMobileStage = 'shown';
    section.dataset.akInitialCoverOpened = 'true';
    section.dataset.akImageRevealBound = 'true';
    section.dataset.akDesktopCenterStopEligible = 'false';
    const cover = section.querySelector('.ak-carousel-image-cover');
    if (cover) {
      cover.classList.remove('ak-carousel-cover-closing','ak-carousel-cover-closed','ak-carousel-cover-opening');
      cover.classList.add('ak-desktop-door-image-visible');
    }
  };
  const settle = () => document.querySelectorAll('section.ak-featured-carousel').forEach(window.akCommitCarouselRevisit);
  document.addEventListener('DOMContentLoaded', settle, {once:true});
  window.addEventListener('ak:prepare-page-reveal', settle);
})();
